import TextWithIcon, { TextWithIconProps } from "common/Text/TextWithIcon";
import TextWithPrecision from "common/Text/TextWithPrecision";
import { PrecisionConfig } from "@shared/types";
import React from "react";
import { RootState } from "app/store";
import { useTextWithPrecisionProps } from "@shared/hooks/text/useTextWithPrecision";

export interface TextWithPrecisionAndIconProps
  extends Omit<TextWithIconProps, "text">,
    useTextWithPrecisionProps {
  precisionSelector?: (state: RootState) => PrecisionConfig | {} | undefined;
}

const TextWithPrecisionAndIcon = ({
  text,
  precisionSelector,
  precisionConfig,
  precisionType,
  precisionCoin,
  iconType,
  iconStyle,
  iconSize,
  exchange,
  coinOrExchangeName,
  justify,
  currency,
  round = false,
  withFallback = false,
  precision,
  style,
  textStyle,
}: TextWithPrecisionAndIconProps) => {
  return (
    <TextWithIcon
      iconType={iconType}
      iconStyle={iconStyle}
      iconSize={iconSize}
      coinOrExchangeName={coinOrExchangeName}
      justify={justify}
      currency={currency}
      style={style}
      textStyle={textStyle}
      text={
        <TextWithPrecision
          text={text}
          precisionSelector={precisionSelector}
          precisionType={precisionType}
          precisionCoin={precisionCoin}
          exchange={exchange}
          round={round}
          precisionConfig={precisionConfig}
          withFallback={withFallback}
          precision={precision}
        />
      }
    />
  );
};
export default TextWithPrecisionAndIcon;
